import { useState } from "react";

import { dateToLocale } from "@/services/Utils";
import CustomButton from "../desktop/button/CustomButton";
import CustomBadge from "../desktop/badge/CustomBadge";

import classes from "./Season.module.scss";

const formatSeasonName = (initial_date, end_date) => {
	const startYear = initial_date.slice(0, 4);
	const endYear = end_date.slice(0, 4);
	return `${startYear} - ${endYear}`;
};

const Season = ({ seasons, setSeasons, showTitle = true, handleDelete }) => {
	const [newSeason, setNewSeason] = useState({ initial_date: "", end_date: "" });
	const [showForm, setShowForm] = useState(false);
	const [editingIndex, setEditingIndex] = useState(null);
	const [editData, setEditData] = useState({ initial_date: "", end_date: "" });

	const addSeason = () => {
		if (!newSeason.initial_date || !newSeason.end_date) return;

		const name = formatSeasonName(newSeason.initial_date, newSeason.end_date);
		const updatedSeasons = seasons.map((s) => ({ ...s, active: false }));

		const allSeasons = [
			...updatedSeasons,
			{
				name,
				initial_date: newSeason.initial_date,
				end_date: newSeason.end_date,
				active: true,
			},
		];

		allSeasons.sort((a, b) => new Date(b.initial_date) - new Date(a.initial_date));
		setSeasons(allSeasons);

		setNewSeason({ initial_date: "", end_date: "" });
		setShowForm(false);
	};

	const toggleActive = (index) => {
		const updated = seasons.map((s, i) => ({
			...s,
			active: i === index,
		}));
		setSeasons(updated);
	};

	const startEdit = (index) => {
		const season = seasons[index];
		setEditingIndex(index);
		setEditData({ initial_date: season.initial_date, end_date: season.end_date });
	};

	const cancelEdit = () => {
		setEditingIndex(null);
		setEditData({ initial_date: "", end_date: "" });
	};

	const saveEdit = (index) => {
		const updatedSeasons = [...seasons];
		const name = formatSeasonName(editData.initial_date, editData.end_date);
		updatedSeasons[index] = {
			...updatedSeasons[index],
			initial_date: editData.initial_date,
			end_date: editData.end_date,
			name,
		};

		updatedSeasons.sort((a, b) => new Date(b.initial_date) - new Date(a.initial_date));
		setSeasons(updatedSeasons);
		cancelEdit();
	};

	return (
		<div className={classes.container}>
			{!!showTitle && <hr />}

			<div className={classes.header}>
				{!!showTitle && <h1>Temporadas</h1>}
				<CustomButton variant={showForm ? "secondary" : "primary"} size="md" onClick={() => setShowForm(!showForm)}>
					{showForm ? "Cancelar" : "Nueva temporada"}
				</CustomButton>
			</div>

			{showForm && (
				<div className={classes.form}>
					<input type="date" value={newSeason.initial_date} onChange={(e) => setNewSeason({ ...newSeason, initial_date: e.target.value })} />
					<input type="date" value={newSeason.end_date} onChange={(e) => setNewSeason({ ...newSeason, end_date: e.target.value })} />
					<CustomButton variant="primary" size="md" onClick={addSeason}>
						Confirmar
					</CustomButton>
				</div>
			)}

			<table className={classes.table}>
				<thead>
					<tr>
						<th>Nombre</th>
						<th>Inicio</th>
						<th>Fin</th>
						<th>Estado</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					{seasons.map((season, index) => (
						<tr key={index}>
							<td>{season.name}</td>
							<td>
								{editingIndex === index ? (
									<input
										type="date"
										value={editData.initial_date}
										onChange={(e) => setEditData({ ...editData, initial_date: e.target.value })}
										className={classes.editInput}
									/>
								) : (
									dateToLocale(season.initial_date)
								)}
							</td>
							<td>
								{editingIndex === index ? (
									<input
										type="date"
										value={editData.end_date}
										onChange={(e) => setEditData({ ...editData, end_date: e.target.value })}
										className={classes.editInput}
									/>
								) : (
									dateToLocale(season.end_date)
								)}
							</td>
							<td>
								<CustomBadge
									variant={season.active ? "success" : "neutral"}
									size="md"
									pill={true}
									onClick={() => !season.active && toggleActive(index)}
									className={!season.active ? classes.clickable : ""}
								>
									{season.active ? "Activa" : "Inactiva"}
								</CustomBadge>
							</td>
							<td className={classes.actions}>
								{editingIndex === index ? (
									<>
										<CustomButton variant="secondary" size="sm" onClick={cancelEdit}>
											Cancelar
										</CustomButton>
										<CustomButton variant="primary" size="sm" onClick={() => saveEdit(index)}>
											Guardar
										</CustomButton>
									</>
								) : (
									<>
										<CustomButton variant="ghost" size="sm" onClick={() => startEdit(index)}>
											Editar
										</CustomButton>

										<CustomButton
											variant="danger"
											size="sm"
											onClick={() => {
												handleDelete(index);
											}}
										>
											Eliminar
										</CustomButton>
									</>
								)}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default Season;
